import pathToRegexp from 'path-to-regexp';
import { curry, type, isNil, isEmpty } from 'ramda';

/**
 * 比较两个url是否相等
 * @param subject_path - 需要的url(正则)，参考: https://www.npmjs.com/package/path-to-regexp
 * @param current_loc - 当前url
 * @returns {boolean}
 */
const isUrlEq = curry(
  (current_loc, subject_path) => !!pathToRegexp(subject_path).exec(current_loc),
);

/* eslint no-useless-escape:0 */
const _reg_url = /(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(?::\d+)?|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/;

/**
 * 是否是合法的url路径
 * @param path - 待检查路径
 * @return {boolean}
 */
const isUrl = (path) => _reg_url.test(path);

const isArray = (operation) => type(operation) === 'Array';

const isObject = (operation) => type(operation) === 'Object';

const isFunction = (operation) => type(operation) === 'Function';

const isExist = (operation) => !isNil(operation) && !isEmpty(operation);

const isIE9 = () => {
  const notIE = { isIE: false, name: null, version: null };

  /* eslint-disable */
  function detectIE10(userAgent) {
    const hasMsie = userAgent.includes('MSIE ');
    return hasMsie
      ? {
          isIE: true,
          name: 'Internet Explorer',
          version: getVersion(userAgent),
        }
      : notIE;
  }
  /* eslint-enable */

  function getVersion(userAgent) {
    const msieRegex = /MSIE (\d*)\.\d*/g;
    return +msieRegex.exec(userAgent)[1];
  }

  const result = detectIE10(window.navigator.userAgent);

  return result.isIE ? result.version === 9 : false;
};

const isIE = () => {
  const inBrowser = typeof window !== 'undefined';
  const UA = inBrowser && window.navigator.userAgent.toLowerCase();
  const isIE = UA && /msie|trident/.test(UA);
  return isIE;
};

export default {
  isUrl,
  isUrlEq,
  isArray,
  isObject,
  isFunction,
  isExist,
  isIE9,
  isIE,
};
